import { render, staticRenderFns } from "./purchase-order-multiselect-ajax.vue?vue&type=template&id=1bedb76b&scoped=true&"
import script from "./purchase-order-multiselect-ajax.vue?vue&type=script&lang=js&"
export * from "./purchase-order-multiselect-ajax.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bedb76b",
  null
  
)

export default component.exports